import React from 'react';
import { Helmet } from 'react-helmet-async';

import { PromptPageMetaProps } from './PromptPage.types';

export const PromptPageMeta: React.FC<PromptPageMetaProps> = ({ title, description }) => {
    const metaTitle = `${title} - промпт для Алиса AI`;
    const metaDescription = `${description}. Подберите для себя подходящий промпт вместе с Алиса AI`;

    return (
        <Helmet>
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
        </Helmet>
    );
};
